var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4434_2517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.71997 9.96996L11.47 3.21996C11.5396 3.15023 11.6223 3.09491 11.7134 3.05717C11.8044 3.01943 11.902 3 12.0006 3C12.0992 3 12.1967 3.01943 12.2878 3.05717C12.3788 3.09491 12.4616 3.15023 12.5312 3.21996L19.2812 9.96996C19.3862 10.0749 19.4577 10.2085 19.4867 10.3541C19.5157 10.4997 19.5009 10.6506 19.4441 10.7877C19.3872 10.9248 19.291 11.042 19.1676 11.1244C19.0441 11.2068 18.899 11.2507 18.7506 11.2506H12.7506V20.2506C12.7506 20.4495 12.6716 20.6403 12.5309 20.7809C12.3903 20.9216 12.1995 21.0006 12.0006 21.0006C11.8017 21.0006 11.6109 20.9216 11.4703 20.7809C11.3296 20.6403 11.2506 20.4495 11.2506 20.2506V11.2506H5.25059C5.10217 11.2507 4.95705 11.2068 4.8336 11.1244C4.71016 11.042 4.61394 10.9248 4.55712 10.7877C4.50031 10.6506 4.48546 10.4997 4.51444 10.3541C4.54343 10.2085 4.61496 10.0749 4.71997 9.96996Z",
    fill: "#EF3633"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4434_2517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowIcon);
export default __webpack_public_path__ + "static/media/UpArrow_icon.17905db54cf2902063309d1d3288f941.svg";
export { ForwardRef as ReactComponent };